module.exports = __webpack_public_path__ + "img/2025-0516-01-01.cfc76804.png";